// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card.chart-item[data-v-c20ace0e]{\n  box-shadow: 0 0 3px 0 rgb(0 0 0);\n}\n@media (min-width: 768px){\n.avg-chart[data-v-c20ace0e]{\n    height: 109px;\n}\n}\n.avg-value-container[data-v-c20ace0e]{\n  margin-top:25%;\n}\n.avg-value[data-v-c20ace0e]{\n  font-size: 60px;\n}\n\n", ""]);
// Exports
module.exports = exports;
